import { AccountLabel } from "@/entities/Labeling/Account.model";

export enum WindowOperation {
    AVERAGE = "a",
    SUM = "s",
    LATEST = "l",
    DELTA = "d",
    COMPLETE_AVERAGE = "ca",
    COMPLETE_SUM = "cs",
}

export const operationLabels = {
    [WindowOperation.AVERAGE]: "Average",
    [WindowOperation.SUM]: "Sum",
    [WindowOperation.LATEST]: "Latest",
    [WindowOperation.DELTA]: "Delta",
    [WindowOperation.COMPLETE_AVERAGE]: "Complete Average",
    [WindowOperation.COMPLETE_SUM]: "Complete Sum",
} as const;

export type MetricQuery = {
    metric: AccountLabel;
    periodResolution: "m" | "q" | "y";
    window?: {
        size: number;
        applyLast: boolean;
        operation: WindowOperation;
    };
    metricQuery: string;
};

export type Value = {
    value: number;
    ref: string;
    meta?: {
        period: string;
        accountId: string;
        dataAssetId: string;
        location: string;
    };
};

export type ParsedMetric = {
    period: string;
    result: number;
    formula: string;
    values: Value[];
};
